import { Request } from "./Requests";
import { SessionStore } from "../uidispatcherapi/SessionStore";
const RequestBuilder = new Request.Builder("evaluate", "article");

export function fetchArticle(ids: string[], storeId: string, customerId: string): Promise<any> {
    const template = "/betty-variants";
    const query = {
        storeIds: storeId,
        ids,
        country: SessionStore.getCountry(),
        locale: SessionStore.getLocale(),
        customerId: customerId || undefined
    };
    return RequestBuilder.path(template, {})
        .query(query)
        .get();
}
